import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BaseCellRendererComponent } from '@examdojo/ag-grid';
import { IconComponent } from '@examdojo/core/icon';
import { PayoutRequestUIModel } from '@examdojo/payments';

@Component({
  selector: 'dojo-extra-bonus-cell-renderer',
  template: `
    <div class="flex h-full items-center gap-2">
      <span>{{ bonusAmount }}</span>
      @if (hasReason) {
        <dojo-icon [icon]="'info-circle'" [matTooltip]="bonusReason" class="cursor-help text-gray-500" />
      }
    </div>
  `,
  imports: [IconComponent, MatTooltipModule],
})
export class ExtraBonusCellRendererComponent extends BaseCellRendererComponent<number, PayoutRequestUIModel> {
  get bonusAmount(): string {
    const amount = this.params?.data?.extra_bonus_in_eur;
    return amount ? `€${amount.toFixed(2)}` : '—';
  }

  get bonusReason(): string {
    return this.params?.data?.extra_bonus_reason ?? '';
  }

  get hasReason(): boolean {
    return !!this.bonusReason;
  }
}
